import axios from "axios";
import defaultHeaders from "./default-headers";
import { isTokenExpired, getNewToken, getToken } from "helpers/auth";

export const login = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/signin`;
  return axios.post(url, params, { headers: { ...defaultHeaders } });
};

export const sendActivationLink = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/send-activation`;
  return axios.post(url, params, { headers: { ...defaultHeaders } });
};

export const forgotPassword = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/password/forgot`;
  return axios.post(url, params, { headers: { ...defaultHeaders } }).then((response) => response.data);
};

export const resetPasswordTokenValidation = (params) => {
  const url = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/reset-password-token/validate`;
  return axios
    .post(url, params, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => response.data);
};

export const resetPassword = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/password/reset`;
  return axios
    .post(url, params, {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => response.data);
};

export const getSubscriptedUserInfo = async ({ memberId, token }) => {
  const response = await axios.get(`${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/members/subscription-detail`, {
    params: {
      memberId,
      activationKey: token,
    },
  });

  return response.data;
};

export const getRefreshToken = (headers) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/auth/refresh`;
  return axios.get(url, { headers });
};

export const isMailAddressUsed = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/members/validate/email`;
  return axios.post(url, params, { headers: { ...defaultHeaders } }).then((response) => response.data);
};

export const isPhoneNumberUsed = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/members/validate/phone`;
  return axios.post(url, params, { headers: { ...defaultHeaders } }).then((response) => response.data);
};

export const getContract = (contractName) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/kvkk/application/desktop-web/form/${contractName}/contract`;
  return axios.get(url).then((response) => response.data);
};

export const signup = (params, type) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/account/${type}/register`;
  return axios
    .post(url, { ...params, application: "desktop-web" }, { headers: { ...defaultHeaders } })
    .then((response) => response.data);
};

export const activateRegistration = (params) => {
  const { memberId, activationToken } = params;
  const url = `${process.env.EJ_APPS_API_HOSTNAME}/e6t/v1/members/${memberId}/activate`;
  return axios.post(url, { activationToken }, { headers: { ...defaultHeaders } }).then((response) => response.data);
};

export const kvkkContractApprove = async (params) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/kvkk/approve`;
  return axios
    .post(url, params, {
      headers: {
        "Content-Type": "application/json",
        "X-From-Channel": "DESKTOP_WEB",
        Authorization: authorization,
      },
    })
    .then((response) => response.data);
};
